import Form from 'react-bootstrap/Form';

export default function SelectFileButton( {fileEvent} ) {
    const handleChange = (e) => {
      fileEvent(e.target.files[0]);
    };
  
    return (
      <Form.Control type="file" role="button" accept=".dvi" onChange={handleChange}></Form.Control>
    );
  }
  